import { useEffect } from "react";

import ActionableItems from "../../../../components/modules/actionable-items";
import Navigation from "../../../../components/navigations/client/detail/navigation";
import useParentLoaderData from "../../../../hooks/useParentLoaderData";
import { NavigationHistoryService } from "../../../../services/navigation-history-service";

export default () => {
  const { _case } = useParentLoaderData(1);

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/actionable-items");
  }, []);

  return (
    <Navigation activeTab="actionable-items" _case={_case}>
      <div className="h-[calc(95vh-64px)] overflow-hidden rounded-b-[15px] bg-white p-4">
        <ActionableItems caseId={_case?.pk} caseObj={_case} />
      </div>
    </Navigation>
  );
};
